import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { StyledLink, StyledText, StyledTitle } from '@selfserve/react-ui';
import { StyledInfoText } from '../feature/forgot-password';
import { routesPaths } from '@selfserve/react-utils';

const StyledInstructionsSentConatiner = styled.div`
  max-width: 528px;
  width: 100%;
`;

const StyledInstructionsSentTitle = styled(StyledTitle)`
  display: block;
  margin-bottom: 40px;
  text-align: center;
`;

const StyledInstructionsSentSubtitle = styled(StyledText)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  font-family: Source Sans Pro;
  font-weight: 600;
  font-size: 18px;
`;

const StyledCheckbox = styled.img`
  margin-right: 21px;
`;

export const InstructionsSentConatiner = () => {
  const { t } = useTranslation();
  return (
    <StyledInstructionsSentConatiner>
      <StyledInstructionsSentTitle centered>
        {t('common.forgot-password-instructions-sent')}
      </StyledInstructionsSentTitle>
      <StyledInstructionsSentSubtitle centered>
        <StyledCheckbox src="assets/checkbox.svg" />
        {t('common.forgot-password-email-sent')}
      </StyledInstructionsSentSubtitle>
      <StyledInfoText centered>
        {t('common.forgot-password-message')}
      </StyledInfoText>
      <StyledLink to={routesPaths.LOGIN} centered bold>
        {t('common.back-to-login')}
      </StyledLink>
    </StyledInstructionsSentConatiner>
  );
};
